import { render, staticRenderFns } from "./VOrderSuccessful.vue?vue&type=template&id=c9e24bba&"
import script from "./VOrderSuccessful.vue?vue&type=script&lang=js&"
export * from "./VOrderSuccessful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports